module.exports = __webpack_public_path__ + "static/media/CTA6.5ec33fe2.avif";